import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Delivery} from "../api";

export class DeliveryService extends RestService<Delivery> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.DELIVERIES)
    }


    send_delivery_details_by_email_with_pdf() {
        return this.instance.post(
            `${this.url}send_delivery_details_by_email_with_pdf`
        )
    }

    send_delivery_details_by_sms() {
        return this.instance.post(`${this.url}send_delivery_details_by_sms`)
    }
}
